import { sync } from 'api/digitalAnalytics';

const logAmplitudeEvent = (eventName, propertiesData = []) => {
  try {
    const digitalAnalyticsProps = {
      event: {
        name: eventName,
        properties: propertiesData,
      },
    };
    sync(digitalAnalyticsProps);
  } catch (error) {
    console.error('Error logging event to Amplitude:', error);
  }
};

export default logAmplitudeEvent;
